export default __webpack_public_path__ + "static/media/50-spring.318e89b3.jpg";